import React from 'react';

import authInit from 'constants/authInit';

export default React.createContext(authInit);
